// Module
var code = "<h1 class=\"heading--isInteriorPageSubHeadingLeft\"> Tax Time Is Here</h1> <p>Your 2024 tax information is available.</p> ";
// Exports
export default code;